import { Container, Form } from 'react-bootstrap';

const FormLabelControl = ({
    field,
    className,
    name,
    labelText,
    placeHolder,
    type,
    isTextArea = false,
}) => {
    return (
        <Container>
            <Form.Group className={className} controlId={name}>
                <Form.Label>{labelText}</Form.Label>
                {isTextArea ? (
                    <Form.Control
                        placeholder={placeHolder}
                        value={field.value}
                        name={field.name}
                        as="textarea"
                        onChange={field.onChange}
                    />
                ) : (
                    <Form.Control
                        placeholder={placeHolder}
                        value={field.value}
                        name={field.name}
                        type={type}
                        onChange={field.onChange}
                    />
                )}
            </Form.Group>
        </Container>
    );
};
export default FormLabelControl;
